 import React from 'react'

    function History() {
      return (
      <div id="History" className="text-justify" style={{ backgroundColor: '#0c2943', color:'#fff'}}>{/*#6372ff 0%, #5ca9fb*/}
      <div className="container">
        <div className="section-title">
          <h1>Nuestra Historia</h1>
          <p>El Club Rotario Bogotá Centenario fue fundado el 21 de marzo de 2005, en conmemoración de los 100 años de Rotary International. Desde sus inicios, bajo la presidencia de Alfredo Arias, el club se destacó por su enfoque en el mecenazgo cultural, apoyando a artistas y proyectos de música y artes plásticas.
Con el tiempo, el club amplió su acción hacia áreas como paz, salud, educación, cultura, medio ambiente y emprendimiento, consolidando una identidad comprometida con el bienestar comunitario y el liderazgo ético.
En 2009, se creó el Rotaract Centenario, fortaleciendo el trabajo con juventudes y promoviendo el relevo generacional en el servicio. Además, el club ha apadrinado al Club Rotario de Soatá (Boyacá), contribuyendo al crecimiento rotario en otras regiones del país.
Hoy, Bogotá Centenario continúa trabajando por transformar vidas mediante proyectos humanitarios y alianzas locales e internacionales, fieles al espíritu de Rotary y al ideal de construir un mundo más justo y pacífico.</p>
        </div>
        </div>
        </div>
      )
    }

    export default History